import { render } from "./UpdateAuth.vue?vue&type=template&id=44cf12e4"
import script from "./UpdateAuth.vue?vue&type=script&lang=js"
export * from "./UpdateAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__